<template>
  <div>
    <v-row
      v-if="prop.hasLink && prop != null"
      @click="openCategoryItem({ id: prop.id, category: $route.params.category, redirect: true })"
      class="ma-0 pa-0 px-2 py-1 section-link"
    >
      <p class="ma-0 pa-0">{{ prop.name }}</p>
    </v-row>
    <v-row
      v-else-if="prop != null"
      class="ma-0 pa-0 px-2 py-1 section-link-no-click"
    >
      <p class="ma-0 pa-0">{{ prop.name }}</p>
    </v-row>
    <slot></slot>
  </div>
</template>

<style>
.section-link-no-click {
  color: #193153;
  font-size: 14px;
  letter-spacing: 0;
}
.section-link {
  color: #193153;
  font-size: 14px;
  letter-spacing: 0;
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import { mapActions } from "vuex";
export default {
  name: "SectionLink",
  props: {
    prop: {
      type: Object,
    },
  },
  methods: {
    ...mapActions("drugs", ["openCategoryItem"]),
  },
  data() {
    return {};
  },
};
</script>